import { sitePreviewTargetFragment } from "../queries"

function formatDescription(siteDescription) {
  const MAX_LENGTH = 355
  if (!siteDescription || siteDescription.length <= MAX_LENGTH)
    return siteDescription
  return `${siteDescription.slice(0, MAX_LENGTH)}...`
}

export default function updatePreviewTargetCache(
  siteId,
  siteBranch,
  directoryPath,
  siteDescription,
  publicName,
  sitePrefix
) {
  return (proxy, { data }) => {
    if (!data.setSitePreviewTargets.success) {
      return
    }
    const fragmentInfo = {
      fragment: sitePreviewTargetFragment,
      id: `Site:${siteId}`,
    }
    const site = proxy.readFragment(fragmentInfo)

    site.publicName = publicName
    site.branch = siteBranch
    site.previewDirectory = directoryPath
    site.description = formatDescription(siteDescription)
    site.sitePrefix = sitePrefix

    proxy.writeFragment({
      ...fragmentInfo,
      data: site,
    })
  }
}
